import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Checkbox from "./Checkbox";

export default function CheckboxButton({
  label = "",
  subLabel = "",
  checked = false,
  onChecked,
  disabled = false,
  className = "",
  ...restProps
}) {
  const checkboxClasses = classnames("btn-checkbox", className, {
    "btn-checkbox--disabled": disabled,
  });
  return (
    <Checkbox
      onChecked={handleOnClick}
      className={checkboxClasses}
      disabled={disabled}
      label={
        <div>
          {label}
          {subLabel && <span className="sub_label">{subLabel}</span>}
        </div>
      }
      checked={checked}
      tabIndex="0"
      {...restProps}
    />
  );

  function handleOnClick(value) {
    onChecked(value);
  }
}

CheckboxButton.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  checked: PropTypes.bool,
  onChecked: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
